require.context('images', true, /\.(png|jpg|jpeg|svg)$/)

import 'es6-promise/auto'
import '../../src/campaign/helper/gampla_entry_btn'
import initFinishLinkButtons from '../../src/campaign/helper/gampla_finish_link_btn'
import Vue from 'vue'
import marked from 'marked/marked.min'

import DetailContents from '../../src/campaign/components/detail-contents.vue'
import MamariDetailContents from '../../src/campaign/components/mamari-detail-contents.vue'
import LastMdContents from '../../src/campaign/components/last-md-contents.vue'
import GamplaEntryBtnDisplayProcess from '../../src/common/helper/gampla_entry_btn_display_process'

document.addEventListener('DOMContentLoaded', () => {
    GamplaEntryBtnDisplayProcess()
    initFinishLinkButtons()

    const CampaignDetailContents = new Vue({
        el: document.getElementById('campaignDetailContents'),
        render: h => h(DetailContents),
    })

    const MamariCampaignDetailContents = new Vue({
        el: document.getElementById('mamariCampaignDetailContents'),
        render: h => h(MamariDetailContents),
    })

    const CampaignLastMdContents = new Vue({
        el: document.getElementById('lastMdContents'),
        render: h => h(LastMdContents),
    })

    if (document.getElementsByClassName('mamari-point').length > 0) {
        const targetIds = ['text0', 'text1', 'text2', 'text3', 'text4', 'text5', 'text6', 'text7', 'text8', 'text9', 'text10']
        targetIds.forEach(function(val){
            const target  = document.getElementById(val)
            const _marked = marked(target.innerHTML, {
                sanitize: true,
                breaks: true
            })
            target.innerHTML = _marked
        })
    }

    const target = document.getElementById('a-type-note-contents')
    if (target) {
        const _marked = marked(target.innerHTML, {
            sanitize: true,
            breaks: true
        })
        target.innerHTML = _marked
    }

    const EntryButton = document.getElementsByClassName('campaign__entry-btn')
    for (let i = 0; i < EntryButton.length; i++) {
        const DisableWith = EntryButton[i].dataset.disableWith
        if(DisableWith === undefined) continue

        EntryButton[i].addEventListener('click', (e) => {
            e.target.disabled = true
            e.target.value    = e.target.dataset.disableWith
            e.target.parentElement.submit()
        }, false)
    }
})
